/*
 * TODO: This is a temporary override of the copy in the database, for purposes
 * of an A/B test. If this variation wins, replace the copy in the database.
 */

export const TimelineTransformCopyFilter = step => {
  switch (step.code) {
    case 'forward_mail':
      return Object.assign(step, {
        shortDescription: 'Forward Mail',
        longDescription: 'File your official USPS® mail forwarding form.',
      });
    case 'tv_internet':
      return Object.assign(step, {
        shortDescription: 'Set up TV & Internet',
        longDescription:
          'Shop for a new plan or transfer your existing service in minutes.',
        recommended: true,
      });
    case 'insurance':
      return Object.assign(step, {
        shortDescription: 'Secure Your Insurance',
        longDescription:
          'Review quotes and lock in coverage from a top provider.',
      });
    case 'promotion':
      return step; // This was tested and the database has been updated to have the best text
    case 'moveiq':
      return Object.assign(step, {
        shortDescription: 'Move Your Stuff',
        longDescription:
          'Hire a moving company, rent a truck, buy boxes, and more.',
      });
    case 'smart_home_own':
      return step; //Will update text using the database
    case 'update_account':
      return Object.assign(step, {
        shortDescription: 'Update Accounts',
        longDescription: 'Update over 15,000 accounts and records in one shot.',
      });
    case 'dmv':
      return Object.assign(step, {
        shortDescription: 'Update Your Driver’s License',
        longDescription: 'Learn how to update your license and registration.',
        icon: 'license',
      });
    case 'utility':
      return Object.assign(step, {
        shortDescription: 'Contact Utilities',
        longDescription:
          'Sign up for or transfer your electric, water, and gas.',
      });
    case 'recommended_provider':
      return Object.assign(step, {
        shortDescription: 'Your Local Guide',
        longDescription: 'Check out essential resources near you.',
      });
    case 'share':
      return Object.assign(step, {
        shortDescription: 'Share Your New Address',
        longDescription: 'Share your move with a personalized message.',
      });
    default:
      return step;
  }
};
